import React from 'react';
import './config/i18n';
import 'shared/styles/main-theme.css';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import Routes from './routes';
import App from 'shared/components/App';
import { ToastHost } from 'shared/ds';
import platforms from 'shared/constants/platforms';
import ErrorBoundary from './components/ErrorBoundary';


const rootElement = document.getElementById('root');

render(
  <Provider store={store}>
    <ErrorBoundary>
      <App platform={platforms.ADMIN}>
        <Routes />
        <ToastHost />
      </App>
    </ErrorBoundary>
  </Provider>,
  rootElement
);
